/**
 * @desc 亚马逊请求报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.platDataFlow.ReportResponseDtoObject, options?: any) {
  return updateResponse(
    http(URL + `/reportRequest`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
